(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["utils/comments/disable-search-link"] = factory();
	else
		root["utils/comments/disable-search-link"] = factory();
})(globalThis, () => {
return 